
import React, {ReactNode} from 'react';
import TemplateComponent, {TemplateComponentProps} from "../../containers/template_page/template_component/template_component";
import {Col, Container, Row} from "react-bootstrap";
import LuissRanking from "./luiss_ranking/luiss_ranking";
import "./rankings.scss";
import Slider from "react-slick";
import {extraSmallLayout} from "../../utils/device";

interface RankingsData {
    title?: string;

    left_text: string;
    left_image?: string;

    center_text: string;
    center_image?: string;

    right_text: string;
    right_image?: string;
}

class Rankings extends TemplateComponent<RankingsData, TemplateComponentProps<RankingsData>> {

    constructor(props: TemplateComponentProps) {
        super(props);

        this.state = {
            slideIndex: 0
        }
    }


    componentRender(data: RankingsData): React.ReactElement<any> {

        let texts = [{
            text: data.left_text,
            image: data.left_image
        }, {
            text: data.center_text,
            image: data.center_image
        }, {
            text: data.right_text,
            image: data.right_image
        }];

        const settings = {
            centerMode: true,
            infinite: true,
            slidesToShow: 1,
            rows: 1,
            dots: true,
            swipeToSlide: true,
            slidesToScroll: 1,
            cssEase: "linear",
            centerPadding: "30px",
            appendDots: (dots: ReactNode) => (
                <>
                    <div className="slick-counter">{this.state.slideIndex + 1}/3</div>
                    <ul className="slick-dots">{dots}</ul>
                </>
            ),
            afterChange: (index: number) => { this.setState({ slideIndex: index }) }
        };

        return (
            <Container className="c11-rankings">
                {data.title &&
                    <Row>
                        <Col>
                            <h3 className="component-grey-title">{data.title}</h3>
                        </Col>
                    </Row>
                }
                <Row>
                    {
                        extraSmallLayout() ?
                            // mobile layout
                            <Col className="luiss-slides-container">
                                <Slider {...settings}>
                                    {texts.map((item, index) =>
                                        <LuissRanking key={"rankings-" + index} {...item}/>
                                    )}
                                </Slider>
                            </Col>
                        :
                            // desktop layout
                            texts.map((item, index) =>
                                <LuissRanking key={"rankings-" + index} {...item}/>
                            )
                    }
                </Row>
            </Container>
        )
    }
}

export default Rankings;
